<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-13 16:44:19
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-06 18:02:44
 * @Description: 病例讨论
-->
<template>
  <div class="home-LoudSpeaker">
    <func-module
      title="病例讨论"
      icon="icon-line-discusstaolun"
      titleColor="#45CAE8"
      rowColor="#DCF6FA"
      publishColor="#19C4E1"
      hoverColor="#0BA3BF"
      :listData="caseDiscussEs"
      :tips="forumTips"
      @intoDetail="intoDiscuss"
      @hanleViewAll="getAllLoudSpeakerData"
      @handlePublish="startNewForum"
    >
      <template #row="{item}">
        <div class="row">
          <div class="row-left">
            <span class="icon-line-discusstaolun iconfont">{{
              item.postTitle
            }}</span>
          </div>
          <div class="row-right">
            <span class="row-right-sub-up">
              <span class="author">{{ item.userName }}</span>
              <span class="time">{{ item.createTm | datetimeFormat }}</span>
            </span>
            <span class="btns">
              <button
                v-if="!item.postContent"
                class="apply"
                @click.stop="applyIntoDiscuss(item)"
              >
                申请加入
              </button>
              <button class="apply" v-else @click.stop="shareDiscuss(item)">
                分享讨论
              </button>
            </span>
          </div>
        </div>
      </template>
    </func-module>

    <el-dialog
      title="申请提示"
      :visible.sync="applyDialogVisible"
      center
      width="30%"
    >
      <span>是否向发布者申请加入？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="applyDialogVisible = false" type="info" size="small"
          >取 消</el-button
        >
        <el-button @click="sureApplyHandler" type="primary" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <post-create
      ref="forum-create"
      title="发布病例讨论"
      :tips="forumTips"
      :base-url="baseUrl"
      :visible.sync="postCreateVisible"
      :has-attachment="true"
      :has-members="true"
      :member-tips="true"
      :showProtocol="true"
      @sensitiveWord="sensitiveWord"
    />
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { Message } from "element-ui";
import PostCreate from "../detail/PostCreate";
import { mapState } from "vuex";
import FuncModule from "@/components/common/FuncModule";

export default {
  name: "forumComponent",
  data() {
    return {
      caseDiscussEs: [],
      applyDialogVisible: false,
      //当前点击加入的讨论
      caseDiscuss: {},
      postCreateVisible: false,
      baseUrl: "/eims-api/discuss/create"
    };
  },
  components: { PostCreate, FuncModule },

  mounted() {
    this.initData();
  },

  watch: {},

  computed: {},

  methods: {
    sensitiveWord(items) {
      this.$confirm("存在敏感词汇：" + items)
        .then(_ => {})
        .catch(_ => {});
    },

    handlerVisible(flag) {
      this.postCreateVisible = flag;
    },

    startNewForum() {
      this.postCreateVisible = true;
      // this.$refs.forum.changeDialogStatus(true)
    },

    sureApplyHandler() {
      this.isLoading = true;
      let that = this;
      http
        .post(window.config.api.baseUrl + "/eims-api/discuss/apply", {
          token: cookie.getCookie("token"),
          data: {
            postCode: that.caseDiscuss.postCode
          }
        })
        .then(response => {
          if (response.data.code === "00000") {
            Message.success({
              message: "您的信息已提交审核！",
              showClose: true
            });
          }
        })
        .finally(() => {
          this.applyDialogVisible = false;
          this.isLoading = false;
        });
    },

    shareDiscuss(item) {
      // 创建输入框元素
      let oInput = document.createElement("input");
      // 将想要复制的值
      oInput.value =
        window.location.origin + "/#/forum/detail?id=" + item.postCode;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      // 弹出复制成功信息
      Message.success({ message: "分享链接已复制！", showClose: true });
      // 复制后移除输入框
      oInput.remove();
    },

    applyIntoDiscuss(item) {
      this.caseDiscuss = item;
      this.applyDialogVisible = true;
    },

    intoDiscuss(item) {
      this.$router.push({
        path: "/forum/detail",
        query: {
          id: item.postCode
        }
      });
    },

    getAllLoudSpeakerData() {
      this.$router.push({ path: "/forum/list" });
    },

    initData() {
      let that = this;

      http
        .post(window.config.api.baseUrl + "/eims-api/discuss/list", {
          token: cookie.getCookie("token"),
          data: {
            currentIndex: 0,
            pageSize: 10
          }
        })
        .then(response => {
          let data = response.data.data;
          that.caseDiscussEs = data.caseDiscussEs.filter(i => {
            return i.status === "1";
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.home-LoudSpeaker {
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: SourceHanSansSC;
  font-weight: 400;
}

.row {
  cursor: pointer;
  background-color: rgb(220, 246, 250);
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  .row-left {
    // width: calc(100% - min(35%, 398px));
    width: 70%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 5px;
    .icon-panel > .icon-line-discusstaolun:before {
      font-size: 30px;
      line-height: 50px;
      color: rgb(69, 202, 232);
    }
    & > .icon-line-discusstaolun:before {
      color: rgb(25, 196, 225);
      padding: 5px 10px;
    }
    span {
      font-size: 18px;
      font-weight: bold;
      width: calc(100% - 10px);
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .row-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // width: calc(min(35%, 398px));
    width: 30%;
    &-sub-up {
      width: calc(100% / 3 * 2);
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .author {
        color: rgb(25, 196, 225);
        // margin-left: 5px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .time {
        color: #8c939d;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .btns {
      margin: 0 10px;
      width: calc(100% / 3 * 1);
      overflow: hidden;
      white-space: nowrap;
      text-align: center;
      .apply {
        color: #f3f3f3;
        height: 25px;
        width: 70px;
        background-color: rgb(25, 196, 225);
        border: 0;
        border-radius: 3px;
      }
      .apply:active {
        background-color: rgb(11, 163, 191);
      }
    }
  }
}

.row:first-child {
  margin-top: 0;
}

.row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/home/ForumComponent.vue